import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BooleanApiModel } from '@app/api/api-models/BooleanApiModel';
import { ActivityTypeApiModel, MoveApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { SkillsOrPerformanceCategoriesOrCallTypes } from '@shared/enums';
import { ActivityDescriptionModel } from '@app/api/api-models/activities/ActivityDescriptionModel';

@Injectable()
export class ActivityTypesService {
  public apiUrl = 'activity-types';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<ActivityTypeApiModel[]> {
    return this.http
      .get<ActivityTypeApiModel[]>(`${this.apiUrl}/get-list`)
      .pipe(map((array) => array.map((x) => new ActivityTypeApiModel().deserialize(x))));
  }

  public add(model: ActivityTypeApiModel): Observable<ActivityTypeApiModel> {
    return this.http.post<ActivityTypeApiModel>(`${this.apiUrl}/add`, model);
  }

  public update(model: ActivityTypeApiModel): Observable<ActivityTypeApiModel> {
    return this.http.put<ActivityTypeApiModel>(`${this.apiUrl}/update`, model);
  }

  public delete(id: string, alternateId: string = null): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}/${alternateId === null ? '' : alternateId}`);
  }

  public move(model: MoveApiModel<string>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }

  public isUsed(id: string): Observable<BooleanApiModel> {
    return this.http.get<BooleanApiModel>(`${this.apiUrl}/is-used/${id}`);
  }

  public getExistingActivityType(payload: ActivityTypeApiModel): Observable<ActivityTypeApiModel> {
    return this.http.post<ActivityTypeApiModel>(`${this.apiUrl}/existing`, payload);
  }

  public getActivityDescription(
    id: number,
    activityType: SkillsOrPerformanceCategoriesOrCallTypes
  ): Observable<ActivityDescriptionModel> {
    return this.http.get<ActivityDescriptionModel>(`${this.apiUrl}/get-activity-description/${id}/${activityType}`);
  }
}
